import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.connectBankAccount.SuccessPage', {
    title: 'Connect Bank Account | Success',
    connectionEstablished: 'Connection established',
    pleaseProceed: "You've successfully connected your bank account. Now, link it to your Xero account.",
    youLlBeRedirected: "You'll be redirected in a few seconds.",
    learnMore: 'Learn more',
    matchToXero: 'Match to Xero bank account',
});
